"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _tooltip = require("../../../tooltip");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var SelectedItem = function SelectedItem(_ref) {
  var children = _ref.children,
    id = _ref.selectProps.id;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
    id: "tip-".concat(id)
  }), /*#__PURE__*/_react["default"].createElement("span", {
    "data-tip": children,
    "data-for": "tip-".concat(id),
    "data-place": "top",
    className: "selected-value"
  }, children));
};
SelectedItem.propTypes = {
  children: _propTypes["default"].node.isRequired,
  selectProps: _propTypes["default"].shape({}).isRequired
};
SelectedItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SelectedItem",
  "props": {
    "children": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "selectProps": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};
var _default = SelectedItem;
exports["default"] = _default;